import "./ErrorMessage.css";

const ErrorMessage = ({ children, style }) => {
  return (
    <div className="Error_container" style={{ ...style }}>
      {children}
    </div>
  );
};

export default ErrorMessage;
